import { EDeductionPlanType } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export interface IDeductionTemplateSummaryItem {
  deduction_type: string;
  count?: number;
}

export interface IDeductionTemplateSummary {
  activeDeductionTypes: IDeductionTemplateSummaryItem[];
  unUsedDeductionTypes: IDeductionTemplateSummaryItem[];
}

export interface IGetDeductionTemplateSummaryRequest {
  companyID: string;
  workerType?:
    | typeof EDeductionPlanType.EMPLOYEE
    | typeof EDeductionPlanType.CONTRACTOR;
}

export const getDeductionTemplateSummary = (axios: IAxiosInstance) => {
  return async (
    params: IGetDeductionTemplateSummaryRequest
  ): Promise<IDeductionTemplateSummary> => {
    const response = await axios.noRetry.get<
      IApiResponse<IDeductionTemplateSummary>
    >("/api/deduction-template-summary", {
      params: {
        company_id: params.companyID,
        worker_type: params.workerType,
      },
    });
    const data = response.data;

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to fetch deduction template summary");
  };
};
